import React, { useEffect } from 'react';
import SEOMeta from '@/components/plumbing/SEOMeta';
import Navigation from '@/components/plumbing/Navigation';
import HeroSection from '@/components/plumbing/HeroSection';
import AboutSection from '@/components/plumbing/AboutSection';
import ServicesIndustriesSection from '@/components/plumbing/ServicesIndustriesSection';
import ProjectsSection from '@/components/plumbing/ProjectsSection';
import CommitmentSection from '@/components/plumbing/CommitmentSection';
import ComplianceSection from '@/components/plumbing/ComplianceSection';
import ServiceAreasSection from '@/components/plumbing/ServiceAreasSection';
import CTASection from '@/components/plumbing/CTASection';
import CapabilityStatement from '@/components/plumbing/CapabilityStatement';
import Footer from '@/components/plumbing/Footer';

export default function Home() {
  useEffect(() => {
    // Handle anchor scroll on page load or hash change
    const hash = window.location.hash;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        setTimeout(() => element.scrollIntoView({ behavior: 'smooth' }), 100);
      }
    }
  }, []);

  return (
    <div className="home-page w-full min-h-[100vh] bg-[#080808] overflow-x-hidden flex flex-col">
      <SEOMeta
        title="Commercial Plumbing Brisbane & SEQ | Oliver & Sons Plumbing"
        description="Commercial plumbing for builders, shopfitters and project teams across Brisbane and South East Queensland, including hydraulic rough-ins, fit-outs, commercial kitchens, bathrooms and trade waste."
        canonical="https://www.oliverandsons.com.au"
      />
      <Navigation />
      <HeroSection />

      <ComplianceSection />

      <section id="projects">
        <ProjectsSection />
      </section>

      <section id="services">
        <ServicesIndustriesSection />
      </section>

      <section id="areas">
        <ServiceAreasSection />
      </section>

      <CommitmentSection />

      <section id="about">
        <AboutSection />
      </section>

      <CapabilityStatement />

      <section id="contact">
        <CTASection />
      </section>

      <div className="bg-[#080808] border-t border-white/5 px-6 py-8">
        <div className="max-w-3xl mx-auto">
          <p className="text-gray-400 text-xs leading-relaxed mb-3">
            All work is carried out in accordance with applicable Australian Standards, project specifications, and site conditions. Scope, timelines, and compliance requirements may vary depending on project details, site access, and regulatory approvals.
          </p>
          <p className="text-gray-400 text-xs leading-relaxed">
            Quotes are based on the information provided at the time of pricing and may be subject to review if project scope or conditions change.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
}